import { Component, OnInit, Input, AfterViewChecked } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AdminComunicadosService } from './admin-comunicados.service';
import { Comunicado } from '../../base/vo/comunicado';
import { PaginationInstance } from 'ngx-pagination';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';


@Component({
	selector: 'app-admin-comunicados',
	templateUrl: './admin-comunicados.component.html',
	styleUrls: ['./admin-comunicados.component.css']
})
export class AdminComunicadosComponent implements OnInit {

	loading: boolean = false;
	comunicados: any;
	nPagina: number = 1;
	totalItens: number = 0;
	nItemsPerPage: number = 7;
	displayModalExcluir = false;
	comunicadoSelecionado: Comunicado;
	displayModalVerComunicado = false;

	constructor(private adminComunicadosService: AdminComunicadosService,
		public router: Router,
		private activatedRoute: ActivatedRoute,
		public messageService: MessageService
	) { }

	ngOnInit() {
		this.initBuscarComunicados();
	}

	initBuscarComunicados() {
		this.nPagina = 1;
		this.callBuscarComunicados();
	}

	callBuscarComunicados() {
		this.loading = true;
		this.adminComunicadosService.buscarComunicados(this.nPagina, this.nItemsPerPage).subscribe(
			response => {
				this.loading = false;
				this.comunicados = response.data.list;
				this.totalItens = response.data.qtdPaginas * this.nItemsPerPage;
			},
			errorResponse => {
				this.loading = false;
				console.log(errorResponse);
			});
	}

	pageChanged(page: number) {
		this.nPagina = page;
		this.callBuscarComunicados();
	}

	goToNovoComunicado() {
		this.router.navigate(['/admin/comunicados/inserir']);
	}

	getTipoComunicado(comunicado) {
		if (comunicado.geral) {
			return "Geral para Rede";
		} else {
			return "Direto para Credenciados";
		}
	}

	excluirComunicado(comunicado) {
		this.displayModalExcluir = true;
		this.comunicadoSelecionado = comunicado;
	}

	excluirNao() {
		this.displayModalExcluir = false;
		this.comunicadoSelecionado = null;
	}

	excluirSim() {
		this.loading = true;
		this.displayModalExcluir = false;
		this.adminComunicadosService.excluirComunicado(this.comunicadoSelecionado.id).subscribe(
			response => {
				this.loading = false;
				this.messageService.add({ severity: 'success', summary: 'Comunicados', detail: 'Comunicado excluído com sucesso!' });
				this.callBuscarComunicados();
			},
			errorResponse => {
				this.loading = false;
				console.log(errorResponse);
			});
	}



	verComunicado(comunicado) {
		this.displayModalVerComunicado = true;
		this.comunicadoSelecionado = comunicado;
	}



	getBotaoComunicado() {
		if (this.comunicadoSelecionado.importante) {
			return 'Estou de acordo'
		} else {
			return 'Marcar como lido';
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/admin/comunicados/admin-comunicados.component.ts